import { render, staticRenderFns } from "./StruggleTabbar.vue?vue&type=template&id=2deaea99&scoped=true&"
import script from "./StruggleTabbar.vue?vue&type=script&lang=js&"
export * from "./StruggleTabbar.vue?vue&type=script&lang=js&"
import style0 from "./StruggleTabbar.vue?vue&type=style&index=0&id=2deaea99&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2deaea99",
  null
  
)

export default component.exports